import React from 'react';
import Immutable from 'immutable';
import styled, {css, withTheme} from 'styled-components';
import * as utils from './datatableutils';
import $ from 'jquery';
import {defaultTheme} from '../../data/themes';
import Icon from '../icon';
import memoizeOne from 'memoize-one';

const DataTableWrapper = styled.div`
	z-index: 0;
	position: relative;
	width: 100%;
	height: 100%;
	outline: none;
	background: ${props => props.theme.tableBackground || defaultTheme.tableBackground};

	&:focus {
		.body {
			tr {
				&.selected {
					background: ${props => props.theme.tableRowFocusedBackground || defaultTheme.tableRowFocusedBackground} !important;
					* {
						color: ${props => props.theme.tableRowFocusedColor || defaultTheme.tableRowFocusedColor};
						font-size: ${props => props.theme.tableRowFocusedFontSize || defaultTheme.tableRowFocusedFontSize};
						font-weight: ${props => props.theme.tableRowFocusedFontWeight || defaultTheme.tableRowFocusedFontWeight};
					}

				}
			}
		}
	}
`;

const Block = styled.div`
	position: absolute;
	overflow: ${props => props.scrollable ? 'auto' : 'hidden'};
	left: 0px;
	top: 0px;

	&.scrollable {
		td:first-child  {
			border-left: none;
		}
	}

	td {
		&:first-child {
			border-left: ${props => props.theme.tableCellRightBorder || defaultTheme.tableCellRightBorder};
		}
		border-right: ${props => props.theme.tableCellRightBorder || defaultTheme.tableCellRightBorder || '1px solid #e3e3e3'};
		border-bottom: ${props => props.theme.tableCellBottomBorder || defaultTheme.tableCellBottomBorder};
	}
	&.body {
		tr {
			height: ${props => props.theme.tableRowHeight || defaultTheme.tableRowHeight || 20}px;

			&:first-child td {
				border-top: none;
			}

			&.actionable {
				cursor: pointer;
			}

			&.checked {
				background: ${props => props.theme.tableRowCheckedBackground};
			}


			&.selected {
				background: ${props => props.theme.tableRowSelectedBackground || defaultTheme.tableRowSelectedBackground} !important;

				* {
					color: ${props => props.theme.tableRowSelectedColor || defaultTheme.tableRowSelectedColor};
					font-size: ${props => props.theme.tableRowSelectedFontSize || defaultTheme.tableRowSelectedFontSize};
					font-weight: ${props => props.theme.tableRowSelectedFontWeight || defaultTheme.tableRowSelectedFontWeight};
				}

			}


			&.canceled, &.cancelled {
				opacity: 0.5;
				span {
					text-decoration: line-through;
				}
			}

			&.deleted {
				opacity: 0.5;
				span {
					text-decoration: line-through;
				}
			}

			&.error {
				td {
					color: ${props => props.theme.tableCellErrorColor || defaultTheme.tableCellErrorColor};
					background: ${props => props.theme.tableCellErrorBackground || defaultTheme.tableCellErrorBackground};
				}
			}

			&[data-hover] {
				* {
					color: ${props => props.theme.tableRowHoverColor || defaultTheme.tableRowHoverColor};
					font-weight: ${props => props.theme.tableRowHoverFontWeight || defaultTheme.tableRowHoverFontWeight};
				}
			}

			&:nth-child(odd) {
				background: ${props => props.theme.tableRowBackground || defaultTheme.tableRowBackground};
				&.checked {
					background: ${props => props.theme.tableRowCheckedBackground};
				}
				&[data-hover] {
					background: ${props => props.theme.tableRowHoverBackground || defaultTheme.tableRowHoverBackground};
				}
			}

			&:nth-child(even) {
				background: ${props => props.theme.tableRowAltBackground || props.theme.tableRowBackground || defaultTheme.tableRowBackground};
				&.checked {
					background: ${props => props.theme.tableRowCheckedBackground};
				}
				&[data-hover] {
					background: ${props => props.theme.tableRowHoverAltBackground || defaultTheme.tableRowHoverAltBackground || props.theme.tableRowHoverBackground || defaultTheme.tableRowHoverBackground};
				}
			}

		}



		* {
			font-size: ${props => props.theme.tableRowFontSize || defaultTheme.tableRowFontSize};
			font-weight: ${props => props.theme.tableRowFontWeight || defaultTheme.tableRowFontWeight};
		}


		td {
			color: ${props => props.theme.tableRowColor || defaultTheme.tableRowColor};
			> span {
				padding:0px ${props => props.theme.tableRowHorizontalPadding || defaultTheme.tableRowHorizontalPadding};
				display: inline-block;
			}

			&.error {
				color: ${props => props.theme.tableCellErrorColor || defaultTheme.tableCellErrorColor};
				background: ${props => props.theme.tableCellErrorBackground || defaultTheme.tableCellErrorBackground};
			}

			&.ok {
				color: ${props => props.theme.tableCellOkColor || defaultTheme.tableCellOkColor};
				background: ${props => props.theme.tableCellOkBackground || defaultTheme.tableCellOkBackground};

			}

			&.warning {
				color: ${props => props.theme.tableCellWarningColor || defaultTheme.tableCellWarningColor};
				background: ${props => props.theme.tableCellWarningBackground || defaultTheme.tableCellWarningBackground};
			}

			&[data-type=number], &[data-type=date], &[data-type=runtime] {
				text-align: right;
			}

			&[data-type=icon], &[data-type=status] {
				text-align: center;
			}

			&.activeIcon {
				cursor: pointer;
				color: ${props => props.theme.activeIconColor};
				.icon {
					opacity: 0.7;
				}
				&:hover {
					.icon {
						opacity: 1;
					}
				}
			}

			&.rowCheckBox {
				padding: 0px;
				text-align: center;
				> span {
					padding: 0px;
				}
				* {
					font-size: 16px;
				}
			}
		}
	}

	&.header {
		z-index: 1;
		background: ${props => props.theme.tableHeaderBackground || defaultTheme.tableHeaderBackground};


		table {
			height: calc( 100% - 1px );
			td {
				&.rowCheckBox {
					padding: 0px;
					text-align: center;
					> span {
						padding: 0px;
					}
					* {
						font-size: 16px;
					}
					cursor: pointer;
				}

				text-align: center;
				padding: 0px 0px;
				border-right: ${props => props.theme.tableHeaderCellRightBorder || defaultTheme.tableHeaderCellRightBorder};
				border-bottom: ${props => props.theme.tableHeaderCellBottomBorder || defaultTheme.tableHeaderCellBottomBorder};

				color: ${props => props.theme.tableHeaderColor || defaultTheme.tableHeaderColor};
				background: ${props => props.theme.tableHeaderBackground || defaultTheme.tableHeaderBackground};
				font-size: ${props => props.theme.tableHeaderFontSize || defaultTheme.tableHeaderFontSize};
				font-weight: ${props => props.theme.tableHeaderFontWeight || defaultTheme.tableHeaderFontWeight};
				text-align: ${props => props.theme.tableHeaderTextAlign || defaultTheme.tableHeaderTextAlign};

				&.sortable {
					cursor:pointer;
					&:hover {
						text-decoration: underline;
					}
				}
				.cell_filler {
					position: relative;
					width: 100%;
					padding: 0px;
					overflow-y: visible;
					white-space: nowrap;

					.text {
						padding: 0px ${props => props.theme.tableHeaderHorizontalPadding || defaultTheme.tableHeaderHorizontalPadding};
						.icon.sort {
							position: relative;
							margin-right: 4px;
							top: -1px;
							font-size: 90%;
							opacity: 0.7;
							&.s2 {
								font-size: 90%;
								opacity: 0.87;
							}
							&.s1 {
								font-size: 100%;
								opacity: 1;
							}

							&[data-name=sortAsc] {
								color: ${props => props.theme.sortAscColor};
							}
							&[data-name=sortDesc] {
								color: ${props => props.theme.sortDescColor};
							}
						}

					}


					.col_resize {
						position: absolute;
						width: 6px;
						top: -50px;
						height: 100px;
						right: 0px;
						// background: red;
						cursor: ew-resize;
					}

				}

			}
		}
	}

`;

const Table = styled.table`
	table-layout: fixed;
	width: 0px;
	border-collapse: collapse;
	cursor: default;


	td {
		white-space: nowrap;
		overflow: hidden;
		padding: 0px 0px;
	}
`;

const EMPTY_LIST = Immutable.List([]);

function calcCheckBoxStatus(rows) {
	if (!rows || rows.size === 0) {
		return 'hidden';
	}
	let checked = false;
	let unchecked = false;
	for (let i=0; i<rows.size; i++) {
		const row = rows.get(i);
		if (row.get('checked')) {
			checked = true;
			if (unchecked) {
				return 'some';
			}
		} else {
			unchecked = true;
			if (checked) {
				return 'some';
			}
		}
	}
	return checked ? 'all' : 'none';
}

class DataTable extends React.PureComponent {

	constructor() {
		super();

		this.onBodyScroll = this.onBodyScroll.bind(this);

		this.onColResize = this.onColResize.bind(this);
		this.onFixedColResize = this.onFixedColResize.bind(this);

		this.onScrollableRowMouseEnter = this.onScrollableRowMouseEnter.bind(this);
		this.onScrollableRowMouseLeave = this.onScrollableRowMouseLeave.bind(this);
		this.onFixedRowMouseEnter = this.onFixedRowMouseEnter.bind(this);
		this.onFixedRowMouseLeave = this.onFixedRowMouseLeave.bind(this);

		this.scrollableBodyRef = React.createRef();
		this.fixedBodyRef = React.createRef();
		this.scrollableHeaderRef = React.createRef();
		this.fixedHeaderRef = React.createRef();
		this.rootRef = React.createRef();

		this.bodyKeyDown = this.bodyKeyDown.bind(this);
		this.bodyKeyUp = this.bodyKeyUp.bind(this);
		this.onRootMouseDown = this.onRootMouseDown.bind(this);

		this.getCheckBoxStatus = memoizeOne(calcCheckBoxStatus);
	}

	onSortRequested(columnName, reset) {
		if (this.props.onSortRequested) {
			this.props.onSortRequested(columnName, reset);
		}
	}

	getFixedCols() {
		return (this.props.fixedColumns || 0);
	}

	getHeaderHeight() {
		return this.props.theme.tableHeaderHeight || defaultTheme.tableHeaderHeight || '20px';
	}

	onRootMouseDown(e) {
		this.focus();
	}

	onIconMouseDown(row, iconId) {
		if (typeof this.props.onIconMouseDown === 'function') {
			this.props.onIconMouseDown(row, iconId);
		}
	}

	onRowAction(row, index, params) {
		if (typeof this.props.onRowAction === 'function') {
			this.props.onRowAction(row, index, params, this.props.ctx);
		}
	}


	getFixedWidth() {
		return utils.getFixedWidth(this.props.columnWidths, this.getFixedCols(), this.props.withRowCheckBox);
	}

	colGroup(firstColIdx, lastColIdx) {
		return (
			<colgroup>
				{
					this.props.withRowCheckBox && firstColIdx === 0 && (
						<col width={utils.getRowCheckBoxWidth()}/>
					)
				}
				{
					(this.props.columns || EMPTY_LIST).map((col, index) => {
						if ((index >= firstColIdx) && (index < lastColIdx)) {
							return <col key={index} width={utils.getColumnWidth(this.props.columnWidths, index)}/>;
						}
					})
				}
			</colgroup>
		)
	}

	getRow(pane, rowIndex) {
		const $tbody = $(pane).children('table').children('tbody');
		if ($tbody.length > 0) {
			return $tbody[0].childNodes[rowIndex];
		} else {
			return null;
		}
	}

	getFixedRow(rowIndex) {
		return this.getRow(this.fixedBodyRef.current, rowIndex);
	}

	getScrollableRow(rowIndex) {
		return this.getRow(this.scrollableBodyRef.current, rowIndex);
	}

	onRowMouseEnter(row1, row2) {
		let rowIndex = -1;
		if (row1) {
			row1.setAttribute('data-hover', '1');
			rowIndex = row1.rowIndex;
		}
		if (row2) {
			row2.setAttribute('data-hover', '1');
			if (rowIndex < 0) {
				rowIndex = row2.rowIndex;
			}
		}
		if (typeof this.props.onRowMouseEnter === 'function') {
			this.props.onRowMouseEnter(rowIndex);
		}
	}

	onRowMouseLeave(row1, row2) {
		if (row1) {
			row1.removeAttribute('data-hover');
		}
		if (row2) {
			row2.removeAttribute('data-hover');
		}
	}

	onScrollableRowMouseEnter(e) {
		this.onRowMouseEnter(e.currentTarget, this.getFixedRow(e.currentTarget.rowIndex));
	}

	onScrollableRowMouseLeave(e) {
		this.onRowMouseLeave(e.currentTarget, this.getFixedRow(e.currentTarget.rowIndex));
	}

	onFixedRowMouseEnter(e) {
		this.onRowMouseEnter(e.currentTarget, this.getScrollableRow(e.currentTarget.rowIndex));
	}

	onFixedRowMouseLeave(e) {
		this.onRowMouseLeave(e.currentTarget, this.getScrollableRow(e.currentTarget.rowIndex));
	}


	getColumns(firstColIdx, lastColIdx) {
		let res = (this.props.columns || EMPTY_LIST);
		if (this.props.leftIcons) {
			res = this.props.leftIcons.concat(res);
		}
		return res.slice(firstColIdx, lastColIdx);
	}

	renderHeaderCheckBox() {
		const status = this.getCheckBoxStatus(this.props.rows);
		return (
			<td
				className="activeIcon rowCheckBox"
				onMouseDown={e => {
					e.preventDefault();
					if (this.props.onAllRowsChecked && status !== 'hidden') {
						this.props.onAllRowsChecked(status === 'none');
					}
				}}
			>
				{
					status === 'hidden' ? null : (
						<Icon
							active
							name={status === 'all' ? 'checked' : status === 'some' ? 'partiallyChecked' : 'unchecked'}
						/>
					)
				}
			</td>
		);
	}

	header(type) {
		const fixedCols = this.getFixedCols();
		const firstColIdx = type === 'fixed' ? 0 : fixedCols;
		const lastColIdx = type === 'fixed' ? fixedCols : (this.props.columns || EMPTY_LIST).size;
		const cols = this.getColumns(firstColIdx, lastColIdx);
		const fixedWidth = this.getFixedWidth();
		const headerHeight = this.getHeaderHeight();
		const style = type === 'fixed' ? utils.getFixedHeaderStyle(fixedWidth, headerHeight) : utils.getScrollableHeaderStyle(fixedWidth, headerHeight);
		const getColumnText = typeof this.props.getColumnText === 'function' ?
			col => {
				const name = col.get('name');
				return col.get('text') || this.props.getColumnText(name) || name;
			} :
			col => col.get('text') || col.get('name');
		const getColumnTitle = typeof this.props.getColumnTitle === 'function' ?
			col => {
				const name = col.get('name');
				return this.props.getColumnTitle(name) || col.get('text') || name;
			} :
			col => col.get('title') || col.get('text') || col.get('name');
		return (
			<Block ref={type === 'fixed' ? this.fixedHeaderRef : this.scrollableHeaderRef} className={'header ' + type} style={style}>
				<Table>
					{this.colGroup(firstColIdx, lastColIdx)}
					<tbody>
						<tr>
						{
							this.props.withRowCheckBox && firstColIdx === 0 && this.renderHeaderCheckBox()
						}
						{
							cols.map((col, index) => {
								const text = getColumnText(col);
								let title = getColumnTitle(col);
								let sortIndex = col.get('sortIndex');
								if (title === text) {
									title = null;
								}
								let sortable = col.get('sortable');
								return (
									<td
										key={index}
										title={title}
										className={sortable ? 'sortable' : ''}
										onMouseDown={e => {
											if (e.defaultPrevented || !sortable) {
												return;
											}
											e.preventDefault();
											this.onSortRequested(col.get('name'), !e.ctrlKey);
										}}
									>
										<div className="cell_filler">
											<span className="text">
												{
													sortIndex && (
														<Icon
															className={'sort s' + Math.abs(sortIndex)}
															name={sortIndex < 0 ? 'sortDesc' : 'sortAsc'}
														/>
													)
												}
												{text}
											</span>
											<div className="col_resize"/>
										</div>
									</td>
								);
							})
						}
						{
							type === 'scrollable' ? <td style={{width: '200px', border: 'none'}}></td>: null
						}
						</tr>
					</tbody>
				</Table>
			</Block>
		);
	}

	bodyKeyDown(e) {
		if (this._keyDownSwitch) {
			return;
		}
		this._keyDownSwitch = true;
		window.clearTimeout(this._keyDownSwitchTimeout);
		if (this.props.onKeyDown) {
			this.props.onKeyDown(e);
			this._keyDownSwitchTimeout = window.setTimeout(() => {
				this._keyDownSwitchTimeout = null;
				this._keyDownSwitch = false;
			}, 1000);
		}
	}

	bodyKeyUp(e) {
		this._keyDownSwitch = false;
	}

	body(type) {
		const selectedRowIndex = this.props.selectedRowIndex;
		const fixedCols = this.getFixedCols();
		const firstColIdx = type === 'fixed' ? 0 : fixedCols;
		const lastColIdx = type === 'fixed' ? fixedCols : (this.props.columns || EMPTY_LIST).size;
		const cols = this.getColumns(firstColIdx, lastColIdx);
		const fixedWidth = this.getFixedWidth();
		const headerHeight = this.getHeaderHeight();
		const style = type === 'fixed' ? utils.getFixedBodyStyle(fixedWidth, headerHeight) : utils.getScrollableBodyStyle(fixedWidth, headerHeight);
		const rows = this.props.rows || EMPTY_LIST;
		const leftIcons = this.props.leftIcons || EMPTY_LIST;
		const getRowClass = typeof this.props.getRowClass === 'function' ? this.props.getRowClass : null;
		let actionableClass = this.props.onRowAction ? ' actionable' : '';
		const getErrorMessage = typeof this.props.getErrorMessage === 'function' ? this.props.getErrorMessage : null;
		const getIconHint = this.props.getIconHint || (() => null);
		const isFixed = type === 'fixed';
		return (
			<Block scrollable={!isFixed} ref={isFixed ? this.fixedBodyRef : this.scrollableBodyRef} className={'body ' + type} style={style}>
				<Table>
					{this.colGroup(firstColIdx, lastColIdx)}
					<tbody>
					{
						rows.map((row, index) => {
							const cells = leftIcons.concat(row.get('cells'));
							let rowClass = row.get('class');
							if (rowClass) {
								rowClass += ' ';
							} else {
								rowClass = '';
							}

							return (
								<tr
									key={index}
									className={rowClass +
										 (getRowClass ? getRowClass(row) || '' : '') +
										 (selectedRowIndex === index ? ' selected' : '') +
										 (row.get('checked') ? ' checked' : '') +
										 actionableClass
									}
									onMouseDown={e => {
										//e.preventDefault();
										if (e.defaultPrevented) {
											this.latestMouseDownTimestamp = 0;
										} else {
											this.latestMouseDownTimestamp = e.timeStamp;
										}
										this.focus();
//										this.onRowAction(row, index);
										if (this.props.onRowSelected) {
											this.props.onRowSelected(index);
										}
									}}
									onClick={e => {
										//console.log(e.timeStamp, this.latestMouseDownTimestamp, e.timeStamp - (this.latestMouseDownTimestamp || 0));
										if ((e.timeStamp - (this.latestMouseDownTimestamp || 0) > 300)) {
											return;
										}
										e.preventDefault();
										this.onRowAction(row, index, {
											ctrlKey: e.ctrlKey,
											altKey: e.altKey
										});
									}}
								>
									{
										this.props.withRowCheckBox && firstColIdx === 0 && (
											<td
												className="activeIcon rowCheckBox"
												onMouseDown={e => {
													e.preventDefault();
													if (this.props.onRowChecked) {
														this.props.onRowChecked(index, !row.get('checked'));
													}
												}}
											>
												<Icon
													name={row.get('checked') ? 'checked' : 'unchecked'}
												/>
											</td>
										)
									}
									{
										cells.slice(firstColIdx, lastColIdx).map((cell, index) => {
											const colName = cols.get(index).get('name');
											if (Immutable.Map.isMap(cell)) {
												const errorCode = cell.get('errorCode');
												let title;
												if (errorCode) {
													title = getErrorMessage ? getErrorMessage(colName, errorCode) : errorCode;
												}
												const icon = cell.get('icon');
												let type;
												let iconId;
												if (icon) {
													iconId = cell.get('iconId');
													type = 'icon';
												}
												if (!type) {
													type = cols.get(index).get('type');
												}
												let className = cell.get('className');
												return (
													<td
														data-type={type}
														key={index}
														className={(errorCode ? 'error' : '') + (className ? ' ' + className : '') + (icon && iconId ? ' activeIcon' : '')}
														onMouseDown={e => {
															if (iconId) {
																e.preventDefault();
																this.onIconMouseDown(row, iconId);
															}
														}}
														title={title || cell.get('hint') || getIconHint(iconId)}
													>
														<span>{
															icon ?
																<Icon
																	name={icon}
																/>
																: cell.get('text')
														}</span>
													</td>
												)
											} else {
												const cellClass = row.get('cellclass_' + colName);
												const cellHint = row.get('cellhint_' + colName);
												return (
													<td className={cellClass} data-type={cols.get(index).get('type')} key={index} title={cellHint}>
														<span>{cell}</span>
													</td>
												)
											}
										})
									}
								</tr>
							)
						})
					}
					</tbody>
				</Table>
				{
						isFixed ? <div style={{width:'1px', height:'200px'}}></div> : null
				}
			</Block>
		);

	}

	onBodyScroll(e) {
		this.fixedBodyRef.current.scrollTop = e.target.scrollTop;
		this.scrollableHeaderRef.current.scrollLeft = e.target.scrollLeft;
	}


	onFixedColResize(e) {
		this.onColResize(e, true);
	}

	onColResize(e, fixed) {
		e.preventDefault();
		const $document = $(document);
		const $this = $(e.target);
		const $td = $this.closest('td');
		const cellIndex = $td[0].cellIndex;
		const col = $td.closest('table').children('colgroup')[0].childNodes[cellIndex];
		const columnIndex = cellIndex + (fixed ? 0 : this.getFixedCols()) + (this.props.withRowCheckBox ? -1 : 0);

		let dragStrtMousePos = e.pageX;
		let dragStrtColWidth = parseInt(col.getAttribute('width'));
		const dragStrtFixedWidth = this.getFixedWidth();
		const scrollableHeader = this.scrollableHeaderRef.current;
		const fixedHeader = this.fixedHeaderRef.current;

		const updateFixedWidth = fixed ? (colWidth) => {
			const fw = dragStrtFixedWidth + colWidth - dragStrtColWidth;
			scrollableHeader.style.left = utils.getScrollableLeftStyle(fw);
			scrollableHeader.style.width = utils.getScrollableWidthStyle(fw);
			fixedHeader.style.width = utils.getFixedWidthStyle(fw);
		} : () => {};

		// mouse move
		$document.bind('mousemove.atc', function(e) {
			if (dragStrtMousePos < 0) {
				return;
			}
			var dif;
			dif = e.pageX - dragStrtMousePos;
			var w = dragStrtColWidth + dif;
			if (w < 10) {
				w = 10;
			};
			updateFixedWidth(w);
			col.setAttribute('width', w);
		});

		$document.bind('mouseup.atc', (e) => {
			$document.unbind('mousemove.atc');
			$document.unbind('mouseup.atc');
			const width = parseInt(col.getAttribute('width'));
			updateFixedWidth(dragStrtColWidth);
			col.setAttribute('width', dragStrtColWidth);
			if (typeof this.props.onColumnWidthChanged === 'function') {
				this.props.onColumnWidthChanged(columnIndex, width);
			}
		});

		e.preventDefault();
	}

	scrollToRow(row) {
		if (!row) {
			return;
		}
		const body = this.scrollableBodyRef.current;
		const scrollTop = body.scrollTop;
		const scrollHeight = body.offsetHeight;
		const scrollBottom = scrollTop + scrollHeight;
		const rowTop = row.offsetTop - 16;
		const rowBottom = rowTop + row.offsetHeight + 88;
		if (rowTop < scrollTop) {
			$(body).animate({
				scrollTop: rowTop
			}, 300);
		} else if (rowBottom > scrollBottom) {
			$(body).animate({
				scrollTop: rowBottom - scrollHeight
			}, 300);
		}
	}

	scrollToSelectedRow() {
		this.scrollToRow($(this.scrollableBodyRef.current).children('table').children('tbody').children('.selected')[0]);
	}


	componentDidMount() {
		this.scrollableBodyRef.current.addEventListener('scroll', this.onBodyScroll);
		$(this.fixedHeaderRef.current).on('mousedown', 'div.col_resize', this.onFixedColResize);
		$(this.scrollableHeaderRef.current).on('mousedown', 'div.col_resize', this.onColResize);
		$(this.fixedBodyRef.current).on('mouseenter', 'tr', this.onFixedRowMouseEnter);
		$(this.fixedBodyRef.current).on('mouseleave', 'tr', this.onFixedRowMouseLeave);
		$(this.scrollableBodyRef.current).on('mouseenter', 'tr', this.onScrollableRowMouseEnter);
		$(this.scrollableBodyRef.current).on('mouseleave', 'tr', this.onScrollableRowMouseLeave);
		this.calculateColumnWidths();

		this.scrollToSelectedRow();
		if (this.props.focusTimestamp) {
			this.focus();
		}
	}

	focus() {
		window.setTimeout(() => {
			if (this.rootRef.current) {
				this.rootRef.current.focus();
			}
		}, 0);
	}

	componentDidUpdate(prevProps) {
		this.calculateColumnWidths();
		if (this.props.focusTimestamp && (this.props.focusTimestamp !== prevProps.focusTimestamp)) {
			this.focus();
		}
		const selectedRow = (this.props.rows || EMPTY_LIST).get(this.props.selectedRowIndex);
		const prevSelectedRow = (prevProps.rows || EMPTY_LIST).get(prevProps.selectedRowIndex);
		if (selectedRow !== prevSelectedRow) {
			this.scrollToSelectedRow();
		}
	}

	componentWillUnmount() {
		this.scrollableBodyRef.current.removeEventListener('scroll', this.onBodyScroll);
		$(this.fixedHeaderRef.current).off('mousedown', 'div.col_resize', this.onFixedColResize);
		$(this.scrollableHeaderRef.current).off('mousedown', 'div.col_resize', this.onColResize);
		$(this.fixedBodyRef.current).off('mouseenter', 'tr', this.onFixedRowMouseEnter);
		$(this.fixedBodyRef.current).off('mouseleave', 'tr', this.onFixedRowMouseLeave);
		$(this.scrollableBodyRef.current).off('mouseenter', 'tr', this.onScrollableRowMouseEnter);
		$(this.scrollableBodyRef.current).off('mouseleave', 'tr', this.onScrollableRowMouseLeave);
	}

	calculateColumnWidths() {
		const currCalculateColumnWidthTimestamp = this.calculateColumnWidthTimestamp || 0;
		const newCalculateColumnWidthTimestamp = this.props.calculateColumnWidthTimestamp || 0;

		if (currCalculateColumnWidthTimestamp >= newCalculateColumnWidthTimestamp || (typeof this.props.setColumnWidths !== 'function')) {
			return;
		}

		const columnWidths = this.props.columnWidths;
		this.calculateColumnWidthTimestamp = newCalculateColumnWidthTimestamp;
		const calcMaxWidths = (header, body, withCheckBox) => {
			let res = [];

			let minIndex = withCheckBox ? 1 : 0;
			$(header).find('tr').each((index, tr) => {
				const cells = tr.childNodes;
				const cellCount = cells.length;
				for (let i = 0; i < cellCount; i++) {
					if (i < minIndex) {
						continue;
					}
					const cellFiller = cells[i].childNodes[0];
					if (!cellFiller) {
						break;
					}
					const w = cellFiller.childNodes[0].offsetWidth + 4;
					const maxW = res[i - minIndex] || 0;
					if (w > maxW) {
						res[i - minIndex] = w;
					}
				}
			});

			$(body).find('tr').each((index, tr) => {
				const cells = tr.childNodes;
				const cellCount = cells.length;
				for (let i = 0; i < cellCount; i++) {
					if (i < minIndex) {
						continue;
					}
					const w = cells[i].childNodes[0].offsetWidth;
					const maxW = res[i - minIndex] || 0;
					if (w > maxW) {
						res[i - minIndex] = w;
					}
				}
			});
			return res;
		};

		let fixedWidths, scrollableWidths;
		if (this.getFixedCols() > 0) {
			fixedWidths = calcMaxWidths(this.fixedHeaderRef.current, this.fixedBodyRef.current, this.props.withRowCheckBox, this.props.withRowCheckBox);
			scrollableWidths = calcMaxWidths(this.scrollableHeaderRef.current, this.scrollableBodyRef.current);
		} else {
			fixedWidths = [];
			scrollableWidths = calcMaxWidths(this.scrollableHeaderRef.current, this.scrollableBodyRef.current, this.props.withRowCheckBox);
		}

		let res = fixedWidths.concat(scrollableWidths);

		if (columnWidths) {
			for (let i=0; i<res.length; i++) {
				const cw = columnWidths.get(i);
				if (typeof cw === 'number') {
					res[i] = cw;
				}
			}
		}
		this.props.setColumnWidths(Immutable.List(res));
	}

	render() {
		return (
			<DataTableWrapper
				className="ps-dataTable"
				tabIndex="-1"
				onKeyDown={this.bodyKeyDown}
				onKeyUp={this.bodyKeyUp}
				ref={this.rootRef}
				onMouseDown={this.onRootMouseDown}
			>
				{this.header('fixed')}
				{this.header('scrollable')}
				{this.body('fixed')}
				{this.body('scrollable')}
			</DataTableWrapper>
		)
	}
}

/*
DataTable.propTypes = {
	columns: PropTypes.instanceOf(Immutable.List),
	columnWidths: PropTypes.instanceOf(Immutable.List),
	onColumnWidthChanged: PropTypes.func,
	fixedColumns: PropTypes.number,
	rows: PropTypes.instanceOf(Immutable.List),
	onRowMouseEnter: PropTypes.func,
	getColumnText: PropTypes.func,
	getColumnTitle: PropTypes.func,
	getRowClass: PropTypes.func,
	onRowAction: PropTypes.func
};
*/

export default withTheme(DataTable);
